import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MeasurementSetupsComponent } from './measurement-setups/measurement-setups.component';

const routes: Routes = [
  {
    path: '',
    component: MeasurementSetupsComponent,
    data: {
      title: 'Measurement Setup',
      urls: [{ title: 'Dashboard', url: '/' }, { title: 'Measurement Setup' }]
    }
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MeasurementSetupRoutingModule { }
